import React, { useEffect, useState } from "react";
import { Container, Row, Col, Table } from "react-bootstrap";
import api from "../../services/api";
import { acesso } from "../../tools/SAP";

import "./styles.css";

export default function ListaParticipacoes({ history, location }) {
  const [audiencias, setAudiencias] = useState([]);
  const [filtroAno, setFiltroAno] = useState("Todos");
  const [anos, setAnos] = useState([]);
  const [argumento, setArgumento] = useState("");
  const [ipv4, setIpv4] = useState("");
  const [usuarioANA] = useState(localStorage.getItem("ANA"));
  // Novo estado para controlar a visibilidade do aviso
  const [mostrarAviso, setMostrarAviso] = useState(true); 

  // Carrega as audiências ao montar o componente
  useEffect(() => {
    async function loadAudiencias() {
      try {
        const response = await api.get(`/api/audiencias`, {});
        setAudiencias(response.data);
      } catch (error) {
        console.error("Erro ao carregar audiências:", error);
      }
    }
    loadAudiencias();
  }, []);

  // Carrega os anos disponíveis para filtro
  useEffect(() => {
    async function loadAnos() {
      try {
        const response = await api.get("/api/audiencias/ano", {});
        setAnos(response.data);
      } catch (error) {
        console.error("Erro ao carregar anos:", error);
      }
    }
    loadAnos();
  }, []);

  // NOVO useEffect para buscar o IP público usando fetch
  useEffect(() => {
    async function retornaIP() {
      try {
        const response = await fetch('https://api.ipify.org?format=json');
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setIpv4(data.ip || "");
      } catch (error) {
        console.error("Erro ao obter o IP:", error);
        setIpv4("");
      }
    }
    retornaIP();
  }, []);

  // NOVO useEffect para verificar a data e hora do aviso
  useEffect(() => {
    const dataLimite = new Date("2025-06-27T20:00:00"); // Define a data e hora limite (30/05/2025 às 20h)

    const verificarAviso = () => {
      const dataAtual = new Date();
      if (dataAtual >= dataLimite) {
        setMostrarAviso(false); // Esconde o aviso se a data/hora limite for atingida
      } else {
        setMostrarAviso(true); // Garante que o aviso esteja visível antes da data limite
      }
    };

    // Chama a função de verificação inicialmente
    verificarAviso();

    // Configura um intervalo para verificar a cada minuto (ou outro período que você preferir)
    // Isso garante que o aviso desapareça assim que a data e hora forem atingidas
    const intervalId = setInterval(verificarAviso, 60 * 1000); // 60 segundos * 1000 milissegundos = 1 minuto

    // Limpa o intervalo quando o componente for desmontado para evitar vazamentos de memória
    return () => clearInterval(intervalId);
  }, []); // O array de dependências vazio garante que este useEffect seja executado apenas uma vez ao montar o componente

  if (ipv4) {
    acesso(ipv4, location.pathname, "");
  }

  function handleChangeSelAno(event) {
    setFiltroAno(event.target.value);
  }

  function handleClickConsulta(id) {
    history.push(`/Consulta/${id}`);
  }

  return (
    <>
      <Container>
        {/* Aviso de manutenção - renderizado condicionalmente */}
        {mostrarAviso && (
          <div style={{
            backgroundColor: '#fff3cd',
            color: '#856404',
            border: '1px solid #ffeeba',
            padding: '10px',
            borderRadius: '5px',
            marginBottom: '15px',
            textAlign: 'center',
            fontWeight: 'bold'
          }}>
            A autenticação via Gov.br está com instabilidade no momento. Nossa equipe já está trabalhando para normalizar o serviço.
          </div>
        )}
        {/* Fim do aviso */}

        <div className={audiencias.filter(aud => aud.ST_INTERNO === (usuarioANA === "S" ? aud.ST_INTERNO : "N") && aud.ST_ENCERRADO !== "S").length === 0 ? "naoMostrar" : ""}>
          <Row>
            <Col sm={12}>
              <label className="descricao">
                <h3>Vigentes:</h3>
              </label>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <Table id="tableContent" striped bordered hover size="sm">
                <thead>
                  <tr>
                    <th width="10%">Número</th>
                    <th width="15%">Meio de Participação</th>
                    <th width="53%">Objeto</th>
                    <th width="22%">Período de Contribuição</th>
                  </tr>
                </thead>
                <tbody>
                  {audiencias.map(audiencia =>
                    (audiencia.ST_INTERNO === (usuarioANA === "S" ? audiencia.ST_INTERNO : "N")) &&
                      (audiencia.ST_ENCERRADO !== "S") ? (
                      <tr
                        data-toggle="tooltip"
                        title="Clique aqui para selecionar"
                        key={audiencia.ID_AUDIENCIA}
                        onClick={() =>
                          handleClickConsulta(audiencia.ID_AUDIENCIA)
                        }
                      >
                        <td>
                          {audiencia.NU_AUDIENCIA}/{audiencia.DT_ANO_AUDIENCIA}
                        </td>
                        <td>{audiencia.DS_MODALIDADE}</td>
                        <td>{audiencia.DS_AUDIENCIA}</td>
                        <td>
                          De {audiencia.DT_INICIO_CONTRIBUICAO} a{" "}
                          {audiencia.DT_FIM_CONTRIBUICAO}
                          <label
                            className={
                              audiencia.ST_ENCERRADO === "P" ? "aberto" : audiencia.ST_ENCERRADO === "N" ? "futuro" : "fechado"}
                          >
                            {audiencia.DS_PERIODO}
                          </label>
                        </td>
                      </tr>
                    ) : null
                  )}
                </tbody>
              </Table>
            </Col>
          </Row>
        </div>
        <Row>
          <Col sm={12}>
            <label className="descricao">
              <h3>Histórico:</h3>
            </label>
          </Col>
        </Row>
        <Row>
          <Col sm={2}>
            <label>Selecione o ano:</label>
          </Col>
          <Col sm={2}>
            <select value={filtroAno} onChange={handleChangeSelAno}>
              <option value="Todos">Todos</option>
              {anos.map(ano => (
                <option key={ano.DT_ANO_AUDIENCIA} value={ano.DT_ANO_AUDIENCIA}>
                  {ano.DT_ANO_AUDIENCIA}
                </option>
              ))}
            </select>
          </Col>
          <Col sm={1}>Pesquisa:</Col>
          <Col sm={7}>
            <input
              id="Argumento"
              type="Text"
              name="Argumento"
              value={argumento}
              onChange={event => setArgumento(event.target.value)}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <Table id="tableContent" striped bordered hover size="sm">
              <thead>
                <tr>
                  <th width="10%">Número</th>
                  <th width="15%">Meio de Participação</th>
                  <th width="53%">Objeto</th>
                  <th width="22%">Período de Contribuição</th>
                </tr>
              </thead>
              <tbody>
                {audiencias.map(audiencia =>
                  (audiencia.ST_INTERNO === (usuarioANA === "S" ? audiencia.ST_INTERNO : "N")) &&
                    (audiencia.ST_ENCERRADO === "S") &&
                    (audiencia.DT_ANO_AUDIENCIA === (filtroAno === "Todos" ? audiencia.DT_ANO_AUDIENCIA : filtroAno)) &&
                    (argumento === "" ? true :
                      (
                        (audiencia.DS_MODALIDADE.toLowerCase().indexOf(argumento.toLowerCase()) !== -1) ||
                        (audiencia.NU_AUDIENCIA.indexOf(argumento.toLowerCase()) !== -1) ||
                        (audiencia.DS_AUDIENCIA.toLowerCase().indexOf(argumento.toLowerCase()) !== -1)
                      )) ? (
                    <tr
                      key={audiencia.ID_AUDIENCIA}
                      data-toggle="tooltip"
                      title="Clique aqui para selecionar"
                      onClick={() =>
                        handleClickConsulta(audiencia.ID_AUDIENCIA)
                      }
                    >
                      <td>
                        {audiencia.NU_AUDIENCIA}/{audiencia.DT_ANO_AUDIENCIA}
                      </td>
                      <td>{audiencia.DS_MODALIDADE}</td>
                      <td>{audiencia.DS_AUDIENCIA}</td>
                      <td>
                        De {audiencia.DT_INICIO_CONTRIBUICAO} a{" "}
                        {audiencia.DT_FIM_CONTRIBUICAO}
                        <label
                          className={
                            audiencia.ST_ENCERRADO === "P" ? "aberto" : audiencia.ST_ENCERRADO === "N" ? "futuro" : "fechado"}
                        >
                          {audiencia.DS_PERIODO}
                        </label>
                      </td>
                    </tr>
                  ) : null
                )}
              </tbody>
            </Table>
          </Col>
        </Row>
      </Container>
    </>
  );
}